// Bước tiểu cảnh toàn cục n = L − 1 và chi phí tu vi (BALANCE §0, §2.1). Không hard-code số cảnh
// giới / tiểu cảnh: mọi thứ suy từ src/data/powerScale (Bất biến 5).
import { BALANCE } from '@data/balance';
import { MAX_STAGE_L, fromStageL, subStageCount } from '@data/powerScale';

export const MAX_STEP = MAX_STAGE_L - 1;

export interface StepInfo {
  /** 1..9 */
  realm: number;
  /** Chỉ số cảnh giới gốc 0 (r). */
  realmIdx: number;
  /** Tiểu cảnh 1..n của cảnh giới. */
  s: number;
  /** Bước cuối của đại cảnh giới (LK9, mọi ĐVM): đầy thanh là viên mãn, không tự đột phá. */
  isLast: boolean;
}

export function stepInfo(step: number): StepInfo {
  const { realm, s } = fromStageL(step + 1);
  return { realm, realmIdx: realm - 1, s, isLast: s === subStageCount(realm) };
}

/** Lượng tu vi để đi từ bước n lên n+1 (ở bước cuối: lượng để đạt viên mãn). */
export function cultCost(step: number): number {
  const r = stepInfo(step).realmIdx;
  return (
    BALANCE.CULT_COST_BASE *
    Math.pow(BALANCE.CULT_COST_STEP_GROWTH, step) *
    Math.pow(BALANCE.CULT_COST_REALM_GROWTH, r) *
    (r === 0 ? BALANCE.CULT_COST_LK_SCALE : 1)
  );
}

/** Trần Dư Khí ở bước cuối (25% cultCost bước cuối). */
export function overflowCap(step: number): number {
  return cultCost(step) * BALANCE.OVERFLOW_QI_CAP_RATIO;
}
